import Vue from 'vue'
import VueRouter from 'vue-router'

import Blog from '@/pages/blog/blog'
import Home from '@/pages/home/home'
import Orthodontics from '@/pages/orthodontics/orthodontics'
import OurPractice from '@/pages/our-practice/our-practice'
import NewPatients from '@/pages/new-patients/new-patients'
import privacyPolicy from '@/pages/privacy-policy/privacy-policy'
import Accessibility from '@/pages/accessibility/accessibility'
import Pedo from '@/pages/pedo/pedo'
import WhyUs from '@/pages/why-choose-us/why-choose-us'
import FreeOrthodonticConsultation from '@/pages/free-orthodontic-consultation/free-orthodontic-consultation'
import ThankYouConsultation from '@/pages/consultation-thank-you/consultation-thank-you'
import VirtualOrthodonticConsultation from '@/pages/virtual-orthodontic-consultation/virtual-orthodontic-consultation'
import ThankYouVirtual from '@/pages/virtual-thank-you/virtual-thank-you'
import PediatricAppointment from '@/pages/pediatric-appointment/pediatric-appointment'
import ThankYouAppointment from '@/pages/appointment-thank-you/appointment-thank-you'
import Covid19 from '@/pages/covid-19/covid-19'
import DentistInCity from '@/pages/dentist-in-city/dentist-in-city'
import DentistInCityNaperville from '@/pages/dentist-in-city-naperville/dentist-in-city-naperville'
import BlogPost from '@/pages/blog-post/blog-post'
import OrthodonticForms from '@/pages/orthodontic-forms/orthodontic-forms'

// import Contact from '@/pages/contact-us/contact-us'

Vue.use(VueRouter)

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return { x: 0, y: 0 }
  } else {
    if (to.hash) {
      return { x: 0, y: 0 }
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
}

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      navigation: false,
      component: Home
    },
    {
      path: '/our-practice',
      name: 'Our Practice',
      navigation: true,
      component: OurPractice,
      children: [
        {
          path: '/our-practice#meet-drs',
          name: 'Meet the Doctors'
        },
        {
          path: '/our-practice#meet-team',
          name: 'Meet the Team'
        },
        {
          path: '#',
          name: 'Office Tour',
          component: OurPractice,
          grandchildren: [
            {
              path: '/our-practice#office-tour-bloomingdale',
              name: 'Office Tour Bloomingdale'
            },
            {
              path: '/our-practice#office-tour-naperville',
              name: 'Office Tour Naperville'
            }
          ]
        },
        {
          path: '/our-practice#community',
          name: 'Community & Office Events'
        },
        {
          path: '/our-practice#directions',
          name: 'Map and Directions'
        }
      ]
    },
    {
      path: '/why-choose-us',
      name: 'Why Choose Us',
      navigation: true,
      component: WhyUs,
      children: [
        {
          path: '/why-choose-us#what-apart',
          name: 'What Sets Us Apart',
          icon: 'sets'
        },
        {
          path: '/why-choose-us#testimonials',
          name: 'Testimonials',
          icon: 'test'
        },
        {
          path: '/why-choose-us#before-after',
          name: 'Before and Afters',
          icon: 'before'
        }
      ]
    },
    {
      path: '/orthodontics',
      name: 'Orthodontics',
      navigation: true,
      component: Orthodontics,
      children: [
        {
          name: 'Treatments',
          path: 'treatments',
          url: '/static/treatments.jpg',
          meta: '/orthodontics',
          grandchildren: [
            {
              path: '/orthodontics/treatments#appliances',
              name: 'Appliances'
            },
            {
              path: '/orthodontics/treatments#braces',
              name: 'Braces'
            },
            {
              path: '/orthodontics/treatments#spark-aligners',
              name: 'Spark Aligners'
            }
          ]
        },
        {
          name: 'All Ages',
          path: 'all-ages',
          url: '/static/all-ages.jpg',
          meta: '/orthodontics',
          grandchildren: [
            {
              path: '/orthodontics/all-ages#children',
              name: 'Children'
            },
            {
              path: '/orthodontics/all-ages#teens',
              name: 'Teens'
            },
            {
              path: '/orthodontics/all-ages#adults',
              name: 'Adults'
            }
          ]
        },
        {
          name: 'Life With Braces',
          path: 'life-with-braces',
          url: '/static/braces.jpg',
          meta: '/orthodontics',
          grandchildren: [
            {
              path: '/orthodontics/life-with-braces#foods',
              name: 'Foods to Avoid'
            },
            {
              path: '/orthodontics/life-with-braces#emergency',
              name: 'Emergency Info'
            },
            {
              path: '/orthodontics/life-with-braces#faq',
              name: 'FAQ'
            }
          ]
        }
      ]
    },
    {
      path: '/pediatric-dentistry',
      name: 'Pediatric Dentistry',
      navigation: true,
      component: Pedo,
      children: [
        {
          name: 'Preventive Care',
          path: 'preventive-care',
          url: '/static/preventive.jpg',
          meta: '/pediatric-dentistry',
          grandchildren: [
            {
              path: '/pediatric-dentistry/preventive-care#exams',
              name: 'Exams'
            },
            {
              path: '/pediatric-dentistry/preventive-care#nutrition',
              name: 'Nutrition'
            },
            {
              path: '/pediatric-dentistry/preventive-care#other',
              name: 'Other Care'
            }
          ]
        },
        {
          name: 'Treatments',
          path: 'pediatric-treatment',
          url: '/static/pedo-treatment.jpg',
          meta: '/pediatric-dentistry',
          grandchildren: [
            {
              path: '/pediatric-dentistry/pediatric-treatment#children-caries',
              name: 'Childhood Caries'
            },
            {
              path: '/pediatric-dentistry/pediatric-treatment#fillings',
              name: 'Fillings & Crowns'
            },
            {
              path: '/pediatric-dentistry/pediatric-treatment#nitrous',
              name: 'Laughing Gas'
            }
          ]
        },
        {
          name: 'Eductional Info',
          path: 'education',
          url: '/static/education.jpg',
          meta: '/pediatric-dentistry',
          grandchildren: [
            {
              path: '/pediatric-dentistry/education#baby-teeth',
              name: 'Baby Teeth'
            },
            {
              path: '/pediatric-dentistry/education#oral-habits',
              name: 'Oral Habits'
            },
            {
              path: '/pediatric-dentistry/education#pedo-faq',
              name: 'FAQ'
            }
          ]
        }
      ]
    },
    {
      path: '/new-patients',
      name: 'New Patients',
      navigation: true,
      component: NewPatients,
      children: [
        {
          path: '/new-patients#insurance',
          name: 'Insurance & Financing'
        },
        {
          path: '/new-patients#forms',
          name: 'Online Patient Forms'
        },
        {
          path: '/new-patients#finance',
          name: 'Office & Financial Policies'
        }
      ]
    },
    {
      path: '/blog',
      name: 'Blog',
      navigation: false,
      component: Blog
    },
    {
      path: '/free-orthodontic-consultation',
      name: 'Free Orthodontic Consultation',
      navigation: false,
      component: FreeOrthodonticConsultation
    },
    {
      path: '/virtual-orthodontic-consultation',
      name: 'Virtual Orthodontic Consultation',
      navigation: false,
      component: VirtualOrthodonticConsultation
    },
    {
      path: '/pediatric-appointment',
      name: 'Pediatric Appointment',
      navigation: false,
      component: PediatricAppointment
    },
    {
      path: '/thank-you-consultation',
      name: 'Thank You Consultation',
      navigation: false,
      component: ThankYouConsultation
    },
    {
      path: '/thank-you-virtual',
      name: 'Thank You Virtual',
      navigation: false,
      component: ThankYouVirtual
    },
    {
      path: '/privacy-policy',
      name: 'Privacy Policy',
      navigation: false,
      component: privacyPolicy
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      navigation: false,
      component: Accessibility
    },
    {
      path: '/thank-you-appointment',
      name: 'Thank You Appointment',
      navigation: false,
      component: ThankYouAppointment
    },
    {
      path: '/covid-19',
      name: 'COVID-19',
      navigation: false,
      component: Covid19
    },
    {
      path: '/dentist-in-city',
      name: 'Dentist In City',
      navigation: false,
      component: DentistInCity
    },
    {
      path: '/dentist-in-city-naperville',
      name: 'Dentist In City Naperville',
      navigation: false,
      component: DentistInCityNaperville
    },
    {
      path: '/orthodontic-forms',
      name: 'Orthodontic Forms',
      navigation: false,
      component: OrthodonticForms
    },
    {
      path: '/blog-post/:id',
      name: 'BlogPost',
      navigation: false,
      component: BlogPost
    },
    {
      path: '/*',
      navigation: false,
      component: Home
    }
  ],
  scrollBehavior
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js